module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#cancel",
      toString: function () {
        return this.url;
      }
    }